const REDUX = {
    reducers: {
        SET_SHOW_HEADER: 'SET_SHOW_HEADER',
        GET_AUTHENTICATED_USER: 'GET_AUTHENTICATED_USER',
        ERROR_AUTHENTICATION: 'ERROR_AUTHENTICATION',
        GET_USER_BY_ACCOUNT_NAME: 'GET_USER_BY_ACCOUNT_NAME',
        SET_USER_TOKEN: 'SET_USER_TOKEN',
        SET_AZURE_TOKEN: 'SET_AZURE_TOKEN',
        GET_ALL_LOCATIONS_PAGINATE: 'GET_ALL_LOCATIONS_PAGINATE',
        GET_ALL_LOCATIONS: 'GET_ALL_LOCATIONS',
        GET_LOCATION_BY_ID: 'GET_LOCATION_BY_ID',
        GET_ALL_LOCATIONS_COUNT: 'GET_ALL_LOCATIONS_COUNT',
        GET_ALL_LOCATIONS_WITH_NOTICATION_COUNT: 'GET_ALL_LOCATIONS_WITH_NOTICATION_COUNT',
        GET_ALL_LOCATIONS_COUNT_LOADING: 'GET_ALL_LOCATIONS_COUNT_LOADING',
        ERROR_LOCATIONS: 'ERROR_LOCATIONS',
        //notification action plan
        GET_ALL_NOTIFICATIONS_TO_DOWNLOAD_CSV_DATA: 'GET_ALL_NOTIFICATIONS_TO_DOWNLOAD_CSV_DATA',
        CLEAN_CSV_DATA: 'CLEAN_CSV_DATA',
        GET_ALL_PLAN_ACTION: 'GET_ALL_PLAN_ACTION',
        LOADING_ALL_PLAN_ACTION: 'LOADING_ALL_PLAN_ACTION',
        ERROR_ALL_PLAN_ACTION: 'ERROR_ALL_PLAN_ACTION',
        // Actions para Plano de Ação em Grupo
        GET_ALL_PLAN_ACTION_GROUP: 'GET_ALL_PLAN_ACTION_GROUP',
        LOADING_ALL_PLAN_ACTION_GROUP: 'LOADING_ALL_PLAN_ACTION_GROUP',
        ERROR_ALL_PLAN_ACTION_GROUP: 'ERROR_ALL_PLAN_ACTION_GROUP',
        CLEAR_PLAN_ACTION_GROUP: 'CLEAR_PLAN_ACTION_GROUP',
        // Actions para Plano de Ação em Massa (Batch)
        CREATE_BATCH_PLAN_ACTION_LOADING: 'CREATE_BATCH_PLAN_ACTION_LOADING',
        CREATE_BATCH_PLAN_ACTION_SUCCESS: 'CREATE_BATCH_PLAN_ACTION_SUCCESS',
        CREATE_BATCH_PLAN_ACTION_ERROR: 'CREATE_BATCH_PLAN_ACTION_ERROR',
        CLEAR_BATCH_PLAN_ACTION_RESULT: 'CLEAR_BATCH_PLAN_ACTION_RESULT',
        UPDATE_BATCH_PLAN_ACTION_LOADING: 'UPDATE_BATCH_PLAN_ACTION_LOADING',
        UPDATE_BATCH_PLAN_ACTION_SUCCESS: 'UPDATE_BATCH_PLAN_ACTION_SUCCESS',
        UPDATE_BATCH_PLAN_ACTION_ERROR: 'UPDATE_BATCH_PLAN_ACTION_ERROR',
        DELETE_BATCH_PLAN_ACTION_LOADING: 'DELETE_BATCH_PLAN_ACTION_LOADING',
        DELETE_BATCH_PLAN_ACTION_SUCCESS: 'DELETE_BATCH_PLAN_ACTION_SUCCESS',
        DELETE_BATCH_PLAN_ACTION_ERROR: 'DELETE_BATCH_PLAN_ACTION_ERROR',
        // Actions para Ishikawa em Massa (Batch)
        CREATE_BATCH_ISHIKAWA_LOADING: 'CREATE_BATCH_ISHIKAWA_LOADING',
        CREATE_BATCH_ISHIKAWA_SUCCESS: 'CREATE_BATCH_ISHIKAWA_SUCCESS',
        CREATE_BATCH_ISHIKAWA_ERROR: 'CREATE_BATCH_ISHIKAWA_ERROR',
        UPDATE_BATCH_ISHIKAWA_LOADING: 'UPDATE_BATCH_ISHIKAWA_LOADING',
        UPDATE_BATCH_ISHIKAWA_SUCCESS: 'UPDATE_BATCH_ISHIKAWA_SUCCESS',
        UPDATE_BATCH_ISHIKAWA_ERROR: 'UPDATE_BATCH_ISHIKAWA_ERROR',
        //location
        GET_LOCATIONS_BY_SECTOR_ID: 'GET_LOCATIONS_BY_SECTOR_ID',
        GET_NOTIFICATIONS: 'GET_NOTIFICATIONS',
        GET_CURRENT_NOTIFICATION: 'GET_CURRENT_NOTIFICATION',
        GET_ALL_NOTIFICATIONS: 'GET_ALL_NOTIFICATIONS',
        GET_ALL_NOTICATIONS_PER_MONTH: 'GET_ALL_NOTICATIONS_PER_MONTH',
        GET_ALL_NOTICATIONS_PER_OMS: 'GET_ALL_NOTICATIONS_PER_OMS',
        GET_ALL_NOTICATIONS_PER_DAMAGE: 'GET_ALL_NOTICATIONS_PER_DAMAGE',
        GET_AUTO_NOTIFICATION: 'GET_AUTO_NOTIFICATION',
        GET_ALL_NOTICATIONS_PER_LOCATION: 'GET_ALL_NOTICATIONS_PER_LOCATION',
        GET_ALL_NOTICATIONS_PER_SECTOR: 'GET_ALL_NOTICATIONS_PER_SECTOR',
        GET_ALL_NOTICATIONS_PER_INCIDENT_SECTOR: 'GET_ALL_NOTICATIONS_PER_INCIDENT_SECTOR',
        GET_ALL_NOTIFICATIONS_COUNT: 'GET_ALL_NOTIFICATIONS_COUNT',
        GET_ALL_NOTIFICATIONS_BY_STATUS: 'GET_ALL_NOTIFICATIONS_BY_STATUS',
        GET_MOST_RECLASSIFIED_INCIDENT_TYPE: 'GET_MOST_RECLASSIFIED_INCIDENT_TYPE',
        GET_COUNT_ALL_NOTIFICATIONS_BY_STATUS:'GET_COUNT_ALL_NOTIFICATIONS_BY_STATUS',
        GET_NOTIFICATION_COUNT_BY_SUB_DAMAGE_LEVEL: 'GET_NOTIFICATION_COUNT_BY_SUB_DAMAGE_LEVEL',
        GET_MULTIPLIER_STATS: 'GET_MULTIPLIER_STATS',
        ALL_USER_NOTIFICATION_STATISTICS: 'ALL_USER_NOTIFICATION_STATISTICS',
        RENDER_NOTIFICATION_SCREEN: 'RENDER_NOTIFICATION_SCREEN',
        ERROR_NOTIFICATIONS: 'ERROR_NOTIFICATIONS',
        GET_ALL_SECTORS: 'GET_ALL_SECTORS',
        GET_ALL_SECTORS_GROUPED_BY_LOCATION: 'GET_ALL_SECTORS_GROUPED_BY_LOCATION',
        GET_ALL_SECTORS_COUNT: 'GET_ALL_SECTORS_COUNT',
        GET_ALL_SECTORS_WITH_NOTIFICATION_COUNT: 'GET_ALL_SECTORS_WITH_NOTIFICATION_COUNT',
        GET_ALL_SECTORS_COUNT_LOADING: 'GET_ALL_SECTORS_COUNT_LOADING',
        GET_LOADING: 'GET_LOADING',
        ERROR_SECTORS: 'ERROR_SECTORS',
        ADD_NEW_SECTOR: 'ADD_NEW_SECTOR',
        UPDATE_SECTOR: 'UPDATE_SECTOR',
        GET_CURRENT_SECTOR: 'GET_CURRENT_SECTOR',
        GET_ALL_USERS_V2: 'GET_ALL_USERS_V2',
        GET_PAGINATED_USERS_WITH_LOCATIONS_AND_SECTORS: 'GET_PAGINATED_USERS_WITH_LOCATIONS_AND_SECTORS',
        GET_ALL_USERS: 'GET_ALL_USERS',
        GET_ALL_USERS_COUNT: 'GET_ALL_USERS_COUNT',
        GET_ALL_VARIABLES: 'GET_ALL_VARIABLES',
        GET_ALL_VARIABLES_COUNT: 'GET_ALL_VARIABLES_COUNT',
        ERROR_VARIABLES: 'ERROR_VARIABLES',
        GET_CURRENT_USER: 'GET_CURRENT_USER',
        ERROR_USERS: 'ERROR_USERS',
        LOAD_NOTIFICATIONS_STAT: 'LOAD_NOTIFICATIONS_STAT',
        LOAD_NOTIFICATIONS: 'LOAD_NOTIFICATIONS',
        SELECT_NOTIFICATION: 'SELECT_NOTIFICATION',
        INIT_UPDATE_LOCATION_SECTOR_LIST: 'INIT_UPDATE_LOCATION_SECTOR_LIST',
        END_UPDATE_LOCATION_SECTOR_LIST: 'END_UPDATE_LOCATION_SECTOR_LIST',
        USERS_LOCATIONS_MANAGERS: 'USERS_LOCATIONS_MANAGERS',
        MESSAGE_SECTOR: 'MESSAGE_SECTOR',
        SHOW_LOADING: 'SHOW_LOADING',
        HIDE_LOADING: 'HIDE_LOADING',
        LAST_RETURN_UPDATE_LOCATION_SECTOR:'LAST_RETURN_UPDATE_LOCATION_SECTOR',
        CURRENT_ISHIKAWA_DIAGRAM: 'CURRENT_ISHIKAWA_DIAGRAM',
        CURRENT_ACCOUNTABILITY_MATRIX: 'CURRENT_ACCOUNTABILITY_MATRIX',
        CURRENT_RESULT_ACCOUNTABILITY_MATRIX: 'CURRENT_RESULT_ACCOUNTABILITY_MATRIX',
        CURRENT_LONDON_PROTOCOL: 'CURRENT_LONDON_PROTOCOL',
        CURRENT_TYPE_OF_DIAGNOSIS: 'CURRENT_TYPE_OF_DIAGNOSIS',
        CURRENT_SENTINEL_EVENT: 'CURRENT_SENTINEL_EVENT',
        NEVER_EVENTS: 'CURRENT_NEVER_EVENTS',
        GET_DAMAGE_LEVEL: 'GET_DAMAGE_LEVEL',
        GET_NOTIFICATION_FACTORS: 'GET_NOTIFICATION_FACTORS',
        GET_NOTIFICATION_PROTOCOL_VARIBLES: 'GET_NOTIFICATION_PROTOCOL_VARIBLES',
        SET_AZURE_TOKEN_ACCESS_TOKEN_EXPIRED: 'SET_AZURE_TOKEN_ACCESS_TOKEN_EXPIRED',
        SET_JWT_TOKEN_ACCESS_TOKEN_EXPIRED: 'SET_JWT_TOKEN_ACCESS_TOKEN_EXPIRED',
        SET_CURRENT_NAV_ITEM: 'SET_CURRENT_NAV_ITEM',
        SET_IS_AUTHENTICATED: 'SET_IS_AUTHENTICATED',
        SET_DAMAGE_LEVEL_LIST: 'SET_DAMAGE_LEVEL_LIST',
        SET_PROGRESS_BAR_NAV_CLICKED: 'SET_PROGRESS_BAR_NAV_CLICKED',
        GET_COUNT_LAST_RECLASSIFIED_INCIDENT_TYPE: 'GET_COUNT_LAST_RECLASSIFIED_INCIDENT_TYPE',
        NOTIFICATION_PROCESS_REQUIRED_STEPS_RULES: 'NOTIFICATION_PROCESS_REQUIRED_STEPS_RULES'
    }
}

export { REDUX }
